import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ScreenContainer from '../ui/ScreenContainer';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import "../../index.css";
import styles from '../../style.js';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import All from './All';
import Waiting from './Waiting';
import Completed from './Completed';
import OnGoing from './OnGoing';
import Canceled from './Canceled';
import BasicPageComponent from '../BasicPageComponent';
import * as icons from './icons'
import {getApprovalsCount} from '../NewProcess/apiRequestService';
import * as Actions from '../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

const tabAll='0';

class ProcessManagement extends Component {
  static propTypes = {
    switchedUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    actions: PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      tabsValue:tabAll
    };
  }

  LoadCount = () => {
    getApprovalsCount()
    .then((response) => {
      this.setState({ data: response.data});
    })
    .catch((exception) => {
      this.props.actions.setNotification("Onay bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getApprovalsCount exception: ' + JSON.stringify(exception));
    });  
  }

  componentDidMount() {
    this.LoadCount();
  }

  // YENİ EKLE:
componentDidUpdate(prevProps) {
  if (prevProps.switchedUserId !== this.props.switchedUserId) {
    this.LoadCount();
    this.setState({ tabsValue: tabAll });
  }
}

  tabsChange = (event,newValue) => {
    this.setState({ tabsValue: newValue });
  };

  tabsClick = (value) => {
    if(value===this.state.tabsValue)
      this.setState({ tabsValue: tabAll });
  };

  render() {
    const { tabsValue, data} = this.state;

    let component;
    switch(tabsValue) {
      case tabAll:
        component = <All {...this.props}/>;
        break;
      case "1":
        component = <Waiting {...this.props} LoadCount={this.LoadCount}/>;
        break;
      case "2":
        component = <OnGoing {...this.props}/>;
        break;
      case "3":
        component = <Completed {...this.props}/>;
        break;
      case "4":
        component = <Canceled {...this.props}/>;
        break;
      default:
        component = null;
    }

    return (
      <div>
      <BasicPageComponent>
      <ScreenContainer>
      <Box sx={{ width: '100%' }}>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

        <Grid item xs={12}>
          <Box sx={{boxShadow: 'none',backgroundColor: 'none'}}>        
            <div className="component">
              <Tabs className='customTabs' value={tabsValue} onChange={this.tabsChange} variant="scrollable"  allowScrollButtonsMobile>  
                  <Tab className={tabsValue===tabAll?'customTab customTabBekleyenAll':'customTab customTabBekleyen'} onClick={() =>this.tabsClick("1")}  icon={<div className='customTabIcon'>{icons.waiting}<span className='customTabIconCount'>{data.waiting}</span></div>} label={<div style={styles.tabHeader} className="customTabLabel">Bekleyen Onaylarım</div>} value="1" />                
                  <Tab className={tabsValue===tabAll?'customTab customTabDevamAll':'customTab customTabDevam'} onClick={() => this.tabsClick("2")}  label={<div style={styles.tabHeader} className="customTabLabel">Devam Eden Süreçler</div>} icon={<div className='customTabIcon'>{icons.ongoing}<span className='customTabIconCount'>{data.onGoing}</span></div>} value="2" />
                  <Tab className={tabsValue===tabAll?'customTab customTabTamamlananAll':'customTab customTabTamamlanan'} onClick={() =>this.tabsClick("3")} icon={<div className='customTabIcon'>{icons.completed}<span className='customTabIconCount'>{data.completed}</span></div>} label={<div style={styles.tabHeader} className="customTabLabel">Tamamlanan Süreçler</div>} value="3" />                  
                  <Tab className={tabsValue===tabAll?'customTab customTabReddedilenAll':'customTab customTabReddedilen'} onClick={() =>this.tabsClick("4")} icon={<div className='customTabIcon'>{icons.canceled}<span className='customTabIconCount'>{data.canceled}</span></div>} label={<div style={styles.tabHeader} className="customTabLabel">Sonuçlandırılmayan Süreçler</div>} value="4" />
              </Tabs>
            </div>       
          </Box>
        </Grid>


<Grid item xs={12}>
  <div key={this.props.switchedUserId || 'default'}>{component}</div>
</Grid>
        
      </Grid>
    </Box>
    </ScreenContainer>
    </BasicPageComponent>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  switchedUserId: state.login.get('switchedUserId')
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
)(ProcessManagement);